import React from 'react';
import Contact from "../components/Contact";


const ContactPage = () => {
    return (
        <React.Fragment >
            <Contact />
        </React.Fragment>
    );
};

export default ContactPage;